import { createReducer } from '@reduxjs/toolkit';
import {
  clearCompanyPolicyAction,
  setCompanyPolicyCoordinatesStatusAction,
  setCompanyPolicyLoadErrorAction,
  setCompanyPolicyLoadingAction,
  setCompanyPolicyUnitAction,
  setCompanyPolicyViewAction,
} from 'store/actions/company-time-registration-policy-actions';
import { ICompanyTimeRegistrationPolicyState } from 'types/company/time-registration/ICompanyTimeRegistrationPolicy';

const initialState: ICompanyTimeRegistrationPolicyState = {
  agencyName: '',
  units: [],
  locations: [],
  loading: false,
  loadError: null,
  coordinatesStatus: null,
};

const companyTimeRegistrationPolicyReducer = createReducer(initialState, builder =>
  builder
    .addCase(setCompanyPolicyViewAction, (state, action) => ({
      ...state,
      agencyName: action.payload.agencyName,
      units: action.payload.units,
      locations: action.payload.locations,
    }))
    .addCase(setCompanyPolicyUnitAction, (state, action) => ({
      ...state,
      units: state.units.map(u => (u.unit === action.payload.unit ? action.payload : u)),
    }))
    .addCase(setCompanyPolicyLoadingAction, (state, action) => ({ ...state, loading: action.payload }))
    .addCase(setCompanyPolicyLoadErrorAction, (state, action) => ({ ...state, loadError: action.payload }))
    .addCase(setCompanyPolicyCoordinatesStatusAction, (state, action) => ({
      ...state,
      coordinatesStatus: action.payload,
    }))
    .addCase(clearCompanyPolicyAction, () => ({ ...initialState })),
);

export default companyTimeRegistrationPolicyReducer;
